import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { motion } from "framer-motion";
import AdminNavbar from "../Components/AdminNavbar";

export default function WhatsappChange() {
  const [whatsapp, setWhatsapp] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch existing WhatsApp number on load
  const fetchWhatsapp = async () => {
    try {
      const res = await axios.get("https://dropshopi.com/api/whatsapp.php");
      if (res.data.status === "success" && res.data.data?.numberwht) {
        setWhatsapp(res.data.data.numberwht);
      }
    } catch (err) {
      console.error("Error fetching WhatsApp number", err);
      Swal.fire("Error", "Failed to fetch current WhatsApp number.", "error");
    }
  };

  useEffect(() => {
    fetchWhatsapp();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!whatsapp.trim()) {
      return Swal.fire("Error", "Please enter WhatsApp number.", "error");
    }

    setLoading(true);

    try {
      const res = await axios.post("https://dropshopi.com/api/whatsapp.php", {
        whatsapp,
      });

      if (res.data.status === "success") {
        Swal.fire("Success", "WhatsApp number updated successfully!", "success");
      } else {
        Swal.fire("Error", res.data.message || "Update failed.", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong while updating.", "error");
    }

    setLoading(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="container py-5 text-white"
      style={{ background: "#121212", minHeight: "100vh" }}
    >
      <AdminNavbar />
      <h2 className="mb-4 text-warning">Update WhatsApp Number</h2>

      <div className="row justify-content-center">
        <div className="col-md-6">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">WhatsApp Number</label>
              <input
                type="text"
                name="whatsapp"
                className="form-control bg-dark text-white border-secondary"
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value)}
                placeholder="Enter WhatsApp number"
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-warning w-100"
              disabled={loading}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Update"
              )}
            </button>
          </form>
        </div>
      </div>
    </motion.div>
  );
}
